import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Ranking from './page/ranking';
import Enuentros from './page/enuentros';
import LlavesHome from './page/llavesHome';
import RankingListado from './page/rankingListado';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:dni?/:liga_id?" element={<Ranking />} />
        <Route path="/ranking/listado" element={<RankingListado />} />
        <Route path="/encuentros" element={<Enuentros />} />
        <Route path="/encuentros/llaves" element={<LlavesHome />} />
      </Routes>
    </BrowserRouter >
  );
}

export default App;
